import React from 'react';
import PrevSVG from 'assets/svg/back.svg';
import DownSVG from 'assets/svg/arrowdown.svg';
import ArrowRightSVG from 'assets/V2/svg/arrow-triangle-right.svg';

const svgs = {
  PREV: PrevSVG,
  DOWN: DownSVG,
  NEXT: ArrowRightSVG,
};

type Props = {
  direction: 'UP' | 'DOWN' | 'PREV' | 'NEXT';
  className?: string;
  onClick: () => void;
};

function ArrowButton({ direction = 'NEXT', className = '', onClick }: Props) {
  return (
    <img
      src={svgs[direction]}
      className={'cursor-pointer ' + className}
      alt='arrow'
      onClick={onClick}
    />
  );
}

export default ArrowButton;
